import {mainQuery} from '@github-ui/react-core/future/main-query'

import {mcpRegistryAppBuilder} from '../config/app-builder'

import type {McpRegistryResponse} from '../types'

export const mcpRegistryRoute = mcpRegistryAppBuilder.createQueryRouteConfig('mcpRegistryRoute', {
  path: '/mcp',
  queries: [
    mainQuery<McpRegistryResponse>({
      queryDeps: ({pathname, searchParams}) => {
        const params = new URLSearchParams()

        // v0.1 API uses 'search' parameter and page-based pagination
        const search = searchParams.get('search') || ''
        const page = searchParams.get('page') || '1'

        params.set('page', page)
        if (search) params.set('search', search)

        const pathWithParams = params.toString() ? `${pathname}?${params.toString()}` : pathname

        return {pathname: pathWithParams}
      },
    }),
  ],
})
